/* ==========================================================================
   MAILLOT DISTRICT — Fiche produit
   --------------------------------------------------------------------------
   1. Ajoute au panier les produits de supplément correspondant aux options
      de personnalisation choisies, en même temps que le maillot.
   2. Alimente l'aperçu de flocage de la fenêtre « Voir un exemple ».
   3. Gère l'ouverture de cette fenêtre.

   Pourquoi des produits de supplément : Shopify ne sait pas attacher un prix
   à une line item property. Chaque option payante s'appuie donc sur un vrai
   produit, choisi dans les réglages du bloc. Le prix affiché est lu sur ce
   produit — il ne peut donc pas diverger de ce qui est facturé.
   ========================================================================== */

(() => {
  const SCOPE = '.product__info-container';

  /* ---------- Aperçu de flocage ---------- */

  function splitNameNumber(raw) {
    const value = (raw || '').trim();
    const match = value.match(/^(.*?)[\s-]*(\d{1,3})$/);
    if (match && match[1].trim()) return { name: match[1].trim(), number: match[2] };
    if (/^\d{1,3}$/.test(value)) return { name: '', number: value };
    return { name: value, number: '' };
  }

  function syncPreview(scope) {
    const dialog = scope.parentElement?.querySelector('dialog.md-example')
      || document.querySelector('dialog.md-example');
    if (!dialog) return;

    const nameInput = scope.querySelector('[data-md-input="name"]');
    const bottomInput = scope.querySelector('[data-md-input="bottom"]');

    const slots = {
      name: dialog.querySelector('[data-md-preview="name"]'),
      number: dialog.querySelector('[data-md-preview="number"]'),
      bottom: dialog.querySelector('[data-md-preview="bottom"]'),
    };

    const parsed = splitNameNumber(nameInput?.value);
    if (slots.name) {
      slots.name.textContent =
        parsed.name || nameInput?.placeholder?.replace(/\s*\d+\s*$/, '') || 'VOTRE NOM';
    }
    if (slots.number) slots.number.textContent = parsed.number || '10';
    if (slots.bottom) {
      slots.bottom.textContent =
        (bottomInput?.value || '').trim() || bottomInput?.placeholder || 'MAILLOT DISTRICT';
    }
  }

  /* ---------- Suppléments ---------- */

  function collectAddons(scope, quantity) {
    const items = [];
    const seen = new Set();

    const push = (variantId, label, detail) => {
      if (!variantId || seen.has(variantId)) return;
      seen.add(variantId);
      items.push({
        id: Number(variantId),
        quantity: quantity,
        properties: { [label]: detail },
      });
    };

    const nameInput = scope.querySelector('[data-md-input="name"]');
    if (nameInput?.value.trim()) {
      push(nameInput.dataset.mdAddon, 'Flocage', nameInput.value.trim().toUpperCase());
    }

    const bottomInput = scope.querySelector('[data-md-input="bottom"]');
    if (bottomInput?.value.trim()) {
      push(bottomInput.dataset.mdAddon, 'Flocage bas', bottomInput.value.trim().toUpperCase());
    }

    const badge = scope.querySelector('[data-md-input="badge"]:checked');
    if (badge?.value) {
      push(badge.dataset.mdAddon, 'Badge', badge.value);
    }

    return items;
  }

  /* ---------- Paiement express et suppléments ----------
     Le bouton express de la fiche (PayPal / Apple Pay / Google Pay) part
     DIRECTEMENT au paiement : il saute le panier, donc il saute aussi
     l'ajout des produits de supplément, qui sont de vraies lignes de panier.
     Constaté sur la commande #1013 du 1er novembre 2026 : le client avait
     tapé « kvaratskhelia 7 », le flocage figurait sur la ligne du maillot
     mais n'avait PAS été facturé. Shopify ne permet pas d'attacher une
     seconde ligne à ce bouton : la seule parade est de le retirer tant
     qu'une option PAYANTE est renseignée. Sans option, il reste en place. */
  function toggleExpress(scope) {
    const form = document.querySelector('form[action*="/cart/add"]');
    const wrap = form && form.querySelector('.shopify-payment-button');
    if (!wrap) return;

    const actif = collectAddons(scope, 1).length > 0;
    wrap.classList.toggle('md-express-off', actif);

    /* On ne laisse pas un trou : à la place du bouton express, un vrai
       bouton d'achat direct qui ajoute TOUT au panier (maillot + options)
       puis part au paiement, où les portefeuilles sont de nouveau proposés
       en haut de page. Le client garde donc un achat en un geste, et son
       adresse enregistrée dans Google Pay ou Apple Pay. */
    let direct = form.querySelector('.md-buynow');
    if (actif && !direct) {
      direct = document.createElement('button');
      direct.type = 'button';
      direct.className = 'md-buynow';
      direct.textContent = 'Passer à la caisse maintenant';
      direct.addEventListener('click', () => acheterDirect(scope, direct));
      wrap.parentNode.insertBefore(direct, wrap.nextSibling);
    } else if (!actif && direct) {
      direct.remove();
    }
  }

  /* Ajoute le maillot ET ses suppléments en UNE seule requête, puis part au
     paiement. Une seule requête : soit tout entre au panier, soit rien, donc
     jamais de flocage facturé sans maillot ni l'inverse. */
  async function acheterDirect(scope, bouton) {
    const form = document.querySelector('form[action*="/cart/add"]');
    const id = form?.querySelector('[name="id"]')?.value;
    if (!id) return;

    const racine = window.Shopify?.routes?.root || '/';
    const qty = Math.max(
      1,
      parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 1
    );

    /* Le maillot porte les mêmes propriétés que par le chemin normal :
       l'atelier doit lire le flocage sur la ligne du maillot. */
    const props = {};
    /* On passe par form.elements et NON par querySelectorAll : les champs de
       personnalisation vivent HORS du <form> dans le DOM, rattachés par leur
       attribut form="…". Seul form.elements les voit. */
    Array.prototype.forEach.call(form.elements, (el) => {
      const nom = el.getAttribute && el.getAttribute('name');
      if (!nom || nom.slice(0, 11) !== 'properties[') return;
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
      props[nom.slice(11, -1)] = el.value;
    });

    const items = [{ id: Number(id), quantity: qty, properties: props }].concat(
      collectAddons(scope, qty)
    );

    bouton.disabled = true;
    bouton.setAttribute('aria-busy', 'true');

    try {
      const r = await fetch(racine + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!r.ok) throw new Error('refus');
      window.location.href = racine + 'checkout';
    } catch (e) {
      /* On ne laisse jamais le client bloqué : on retombe sur le bouton
         normal, qui a son propre traitement d'erreur et son tiroir. */
      bouton.disabled = false;
      bouton.removeAttribute('aria-busy');
      form.querySelector('[name="add"]')?.click();
    }
  }

  function bindForm(scope) {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form || form.dataset.mdBound) return;
    form.dataset.mdBound = '1';

    form.addEventListener(
      'submit',
      async (event) => {
        /* Second passage : les suppléments sont déjà au panier, on laisse
           Dawn ajouter le maillot normalement. */
        if (form.dataset.mdPending === '1') {
          form.dataset.mdPending = '';
          return;
        }

        const qtyInput = form.querySelector('input[name="quantity"]');
        const quantity = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
        const items = collectAddons(scope, quantity);
        if (!items.length) return;

        /* On intercepte avant le gestionnaire de Dawn (phase de capture),
           on ajoute les suppléments, puis on relance la soumission. */
        event.preventDefault();
        event.stopImmediatePropagation();

        const submit = form.querySelector('[type="submit"]');
        submit?.setAttribute('aria-busy', 'true');

        try {
          await fetch(window.Shopify?.routes?.root
            ? `${window.Shopify.routes.root}cart/add.js`
            : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
        } catch (error) {
          /* Un supplément qui échoue ne doit jamais empêcher l'achat
             du maillot : on continue quoi qu'il arrive. */
        } finally {
          submit?.removeAttribute('aria-busy');
        }

        form.dataset.mdPending = '1';
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submit || undefined);
        else form.submit();
      },
      true
    );
  }

  /* ---------- Fenêtre « Voir un exemple » ---------- */

  function bindExample(scope) {
    document.querySelectorAll('[data-md-example-open]').forEach((opener) => {
      if (opener.dataset.mdBound) return;
      opener.dataset.mdBound = '1';

      const dialog = document.getElementById(opener.dataset.mdExampleOpen);
      if (!dialog) return;

      ['input', 'change', 'click'].forEach((type) =>
        dialog.addEventListener(type, (e) => e.stopPropagation())
      );

      opener.addEventListener('click', () => {
        syncPreview(scope);
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });

      dialog.querySelectorAll('[data-md-example-close]').forEach((b) =>
        b.addEventListener('click', () => dialog.close())
      );
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) dialog.close();
      });
    });
  }

  /* ---------- Dates de livraison ----------
     Le Liquid calcule déjà les dates à partir de `now`, mais une page servie
     depuis le cache de Shopify peut afficher celles de la veille. On les
     recalcule donc à l'affichage, sur l'horloge du visiteur. */

  function frDate(d) {
    return d.getDate() + '/' + String(d.getMonth() + 1).padStart(2, '0');
  }

  /* Avance de `n` JOURS CALENDAIRES : week-ends compris.
     Sert à la RÉCEPTION, que le client compte en jours réels. */
  function inCalendarDays(n) {
    const d = new Date();
    d.setHours(12, 0, 0, 0); /* midi : à l'abri des changements d'heure */
    d.setDate(d.getDate() + n);
    return d;
  }

  /* Avance de `n` JOURS OUVRÉS : on saute samedis et dimanches.
     Sert à l'EXPÉDITION : l'atelier ne prépare pas le week-end.
     Les jours fériés ne sont pas gérés. */
  function inDays(n) {
    const d = new Date();
    d.setHours(12, 0, 0, 0); /* midi : à l'abri des changements d'heure */
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      const w = d.getDay();
      if (w !== 0 && w !== 6) added += 1;
    }
    return d;
  }

  function refreshDelivery() {
    document.querySelectorAll('[data-md-delivery]').forEach((box) => {
      const n = (key, fallback) => {
        const v = parseInt(box.dataset[key], 10);
        return isNaN(v) ? fallback : v;
      };
      const prepMin = n('prepMin', 1);
      const prepMax = n('prepMax', 2);
      const shipMin = n('shipMin', 7);
      const shipMax = n('shipMax', 15);

      const write = (slot, from, to, avance) => {
        const el = box.querySelector('[data-md-when="' + slot + '"]');
        if (!el) return;
        const a = frDate(avance(from));
        const b = frDate(avance(to));
        el.textContent = a === b ? a : a + ' — ' + b;
      };

      /* Expédition en jours ouvrés, réception en jours calendaires :
         les deux compteurs sont indépendants, la réception ne s'ajoute
         pas à la préparation. */
      write('ship', prepMin, prepMax, inDays);
      write('recv', shipMin, shipMax, inCalendarDays);
    });
  }

  /* ---------- Paliers d'offres (sous le bouton d'achat) ----------

     Le Liquid de snippets/md-goals.liquid a déjà calculé l'état au rendu.
     On le recalcule ici sur le panier réel : une page servie depuis le cache
     Shopify montrerait sinon un panier périmé. Même formule des deux côtés —
     les modifier ensemble. */

  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
  }

  function paintGoals(nb, cents) {
    const box = document.querySelector('.md-goals[data-md-goals]');
    if (!box) return;

    const g1 = Number(box.dataset.goal1) || 2;
    const g2 = Number(box.dataset.goal2) || 4;
    const seuil = Number(box.dataset.bonusCents) || 4000;

    const pct = Math.min(100, Math.round((nb / g2) * 100));
    const reste1 = g1 - nb;
    const reste2 = g2 - nb;
    /* « débloqué » uniquement si les 40 € DE MAILLOTS sont atteints : c'est
       la vraie condition des -5 % auto, on n'annonce jamais une offre que Shopify
       refuserait au paiement (règle n°8). */
    const bonus = nb >= g1 && cents >= seuil;
    /* La remise auto -5 % et « le 4e offert » sont de classe PRODUIT : Shopify
       n'en applique qu'une, la plus grosse. Des 4 maillots on n'annonce donc
       plus les -5 % (verifie en caisse le 2 novembre 2026). */
    const bonusActif = bonus && nb < g2;

    let html;
    if (reste2 <= 0) {
      html =
        '<b>Le meilleur palier est atteint</b>&nbsp;: ton maillot le moins cher est offert';
    } else if (reste1 > 0) {
      html =
        'Plus que <b>' + reste1 + ' maillot' + (reste1 > 1 ? 's' : '') +
        '</b> pour <b>&minus;5&nbsp;%</b> de plus, appliqu&eacute;s tout seuls';
    } else if (!bonus) {
      html =
        'Plus que <b>' + euros(seuil - cents) +
        '</b> de maillots pour <b>&minus;5&nbsp;%</b> de plus, appliqu&eacute;s tout seuls';
    } else {
      html =
        '<b>&minus;5&nbsp;% appliqu&eacute;s automatiquement.</b> Plus que ' + reste2 + ' maillot' +
        (reste2 > 1 ? 's' : '') + ' et le moins cher est offert';
    }

    const msg = box.querySelector('[data-md-goals-msg]');
    if (msg && msg.innerHTML !== html) msg.innerHTML = html;

    const fill = box.querySelector('[data-md-goals-fill]');
    if (fill) fill.style.width = pct + '%';

    const track = box.querySelector('.md-goals__track');
    if (track) track.setAttribute('aria-valuenow', String(nb));

    const s1 = box.querySelector('[data-md-goals-step="1"]');
    const s2 = box.querySelector('[data-md-goals-step="2"]');
    if (s1) {
      s1.classList.toggle('is-on', bonusActif);
      s1.classList.toggle('is-off', nb >= g2);
    }
    if (s2) s2.classList.toggle('is-on', nb >= g2);
  }

  async function refreshGoals() {
    if (!document.querySelector('.md-goals[data-md-goals]')) return;
    const racine = window.Shopify?.routes?.root || '/';
    try {
      const r = await fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) return;
      const cart = await r.json();
      let nb = 0;
      let cents = 0;
      (cart.items || []).forEach((it) => {
        /* /cart.js ne renvoie PAS les tags des produits : les 3 options
           payantes sont les seules dont le handle commence par « option- ». */
        if ((it.handle || '').slice(0, 7) === 'option-') return;
        nb += it.quantity || 0;
        cents += it.final_line_price != null ? it.final_line_price : it.line_price || 0;
      });
      paintGoals(nb, cents);
    } catch (e) {
      /* on garde l'état rendu par Liquid */
    }
  }

  /* Dawn réécrit la bulle du panier après chaque changement : c'est le signal
     le plus fiable, tiroir ouvert ou non. */
  function watchCart() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || bubble.dataset.mdCartWatch) return;
    /* PIEGE : ne JAMAIS poser ici un dataset qui produise data-md-goals.
       dataset.mdGoals ecrit data-md-goals="1" sur la bulle du panier, et
       document.querySelector('.md-goals[data-md-goals]') tombait alors sur la bulle
       au lieu de la barre - repeinte silencieusement impossible. */
    bubble.dataset.mdCartWatch = '1';
    new MutationObserver(() => refreshGoals()).observe(bubble, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    const scope = document.querySelector(SCOPE);
    if (!scope) return;
    refreshDelivery();
    bindForm(scope);
    bindExample(scope);
    toggleExpress(scope);
    watchCart();
    refreshGoals();
    scope.querySelectorAll('[data-md-input]').forEach((input) => {
      if (input.dataset.mdSync) return;
      input.dataset.mdSync = '1';
      const maj = () => { syncPreview(scope); toggleExpress(scope); };
      input.addEventListener('input', maj);
      input.addEventListener('change', maj);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  /* Dawn recharge la section au changement de variante et remplace le bloc
     de personnalisation : on se rebranche à ce moment-là. Les gardes
     `dataset.mdBound` rendent l'appel sans effet si rien n'a bougé. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:change', init);
  document.addEventListener('change', (e) => {
    if (e.target.closest?.('variant-selects')) setTimeout(init, 350);
  });
  init();
})();
